
import { EntityService } from '@/services/entity.service'
import Vue from 'vue'
import Edit from './Edit.vue'

const entityService = new EntityService()

export default Vue.extend({
  name: 'RetentionsList',
  components: {
    Edit
  },
  data: () => ({
    entity: 'suppliers',
    search: '',
    listData: [],
    headers: [
      {
        text: 'Nombre',
        value: 'id_value'
      },
      {
        text: 'Nit',
        value: 'id_type'
      },
      {
        text: 'Iva',
        value: 'tax'
      },
      {
        text: 'Retención 1',
        value: 'retention_1'
      },
      {
        text: 'Retención 2',
        value: 'retention_2'
      },
      {
        text: '',
        value: 'actions',
        align: 'right'
      }
    ],
    showModalEdit: false,
    editEntity: {}
  }),
  async created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.listData = await entityService.getList(this.entity)
    },
    async syncProviders () {
      const response = await entityService.getList('suppliers/sync')
      alert(response.length + ' Proveedores Sincronizados')
    },
    /* getStatusLabelColor (status: string) {
      switch (status) {
        case 'admin':
          return {
            label: 'Administrador',
            color: '#13DEB9FF'
          }
        case 'user':
          return {
            label: 'Usuario',
            color: '#49BEFFFF'
          }
        default:
          return {
            label: '',
            color: ''
          }
      }
    }, */
    editEntityAction (entity: object) {
      this.editEntity = entity
      this.showModalEdit = true
    }
  },
  watch: {
    showModalNew (value) {
      if (!value) this.loadData()
    },
    showModalEdit (value) {
      if (!value) this.loadData()
    }
  }
})
